"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Translation Registry
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyExperimentRegisterPayloadToJSON = exports.CopyExperimentRegisterPayloadFromJSONTyped = exports.CopyExperimentRegisterPayloadFromJSON = exports.instanceOfCopyExperimentRegisterPayload = void 0;
var runtime_1 = require("../runtime");
var CopyTagQuery_1 = require("./CopyTagQuery");
/**
 * Check if a given object implements the CopyExperimentRegisterPayload interface.
 */
function instanceOfCopyExperimentRegisterPayload(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCopyExperimentRegisterPayload = instanceOfCopyExperimentRegisterPayload;
function CopyExperimentRegisterPayloadFromJSON(json) {
    return CopyExperimentRegisterPayloadFromJSONTyped(json, false);
}
exports.CopyExperimentRegisterPayloadFromJSON = CopyExperimentRegisterPayloadFromJSON;
function CopyExperimentRegisterPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'queries': !(0, runtime_1.exists)(json, 'queries') ? undefined : (json['queries'].map(CopyTagQuery_1.CopyTagQueryFromJSON)),
    };
}
exports.CopyExperimentRegisterPayloadFromJSONTyped = CopyExperimentRegisterPayloadFromJSONTyped;
function CopyExperimentRegisterPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'queries': value.queries === undefined ? undefined : (value.queries.map(CopyTagQuery_1.CopyTagQueryToJSON)),
    };
}
exports.CopyExperimentRegisterPayloadToJSON = CopyExperimentRegisterPayloadToJSON;
